import React, { memo, useMemo } from 'react';
import { Keyboard, StyleSheet, View } from 'react-native';
import Text from 'design-system/Text';
import { CollapsableContainer, LineSeparator, rem } from 'design-system';
import IconCircle from 'design-system/icons/IconCircle';
import IconTransactionCategory from 'features/transactions/icons/IconTransactionCategory';
import { isWeb } from '../../../constants';
const BudgetCategoryExcludedRow = ({ budget, subcategories, }) => {
    const txnCategory = useMemo(() => {
        const id = budget.key?.split('.')[1];
        return {
            id: id,
            emoji: budget.emoji ?? undefined,
        };
    }, [budget.emoji, budget.key]);
    return (<View>
      <View style={styles.container}>
        <IconCircle width={44} height={44}>
          <IconTransactionCategory category={txnCategory}/>
        </IconCircle>
        <View style={styles.content}>
          <View style={styles.flex}>
            <Text Text-16>{budget.displayName}</Text>
          </View>
        </View>
      </View>

      {!budget.parentCategoryId && !!subcategories?.length && (<>
          <LineSeparator noMargin/>
          <CollapsableContainer titleContent={<Text Text-16 Secondary>
                Subcategories
              </Text>} isCollapsedByDefault={false} hideBorder style={styles.collapsableContainer} onCollapsedChange={Keyboard.dismiss}>
            {subcategories.map((subcategory) => (<BudgetCategoryExcludedRow key={subcategory.key} budget={subcategory}/>))}
          </CollapsableContainer>
        </>)}
    </View>);
};
const styles = StyleSheet.create({
    flex: {
        flex: 1,
    },
    container: {
        padding: rem(16),
        flexDirection: 'row',
        alignItems: 'center',
        ...(isWeb && {
            paddingHorizontal: rem(8),
        }),
    },
    content: {
        flexDirection: 'row',
        flex: 1,
        alignItems: 'center',
        justifyContent: 'space-between',
        marginStart: rem(16),
    },
    collapsableContainer: {
        ...(isWeb && {
            margin: -rem(8),
        }),
    },
});
export default memo(BudgetCategoryExcludedRow);
